import React from 'react';

/**
 * 이벤트의 `preventDefault()`를 호출한다.
 * @param event 대상 이벤트 객체.
 * @returns 대상 이벤트 객체.
 */
export const prevent = <E extends Event | React.SyntheticEvent>(event: E): E => {
  event?.preventDefault?.();
  return event;
};
